/* 游学管理 */
export default {
  selectStudyTourInfo: "/studyTourInfo/selectPage", // 游学列表
  selectStudyTourInfoDetail: "/studyTourInfo/detail", // 游学列表详情
  insertStudyTourInfo: "/studyTourInfo/insert", // 游学列表新增
  updateStudyTourInfo: "/studyTourInfo/update", // 游学列表修改
  deleteTourInfo: "/studyTourInfo/delete", // 游学列表删除
  updateStatusTourInfo: "/studyTourInfo/updateStatus", // 游学列表上下架
  selectStudyTourUser: "/studyTourInfo/selectStudyTourUser", // 已购用户列表
  exportStudyTourUser: "/studyTourInfo/exportStudyTourUser", // 已购用户列表-导出

  getStudyTourCategoryPage: "/studyTourCategory/selectPage", // 游学分类列表
  getStudyTourCategoryList: "/studyTourCategory/selectList", // 游学分类下拉
  newAddStudyTourCategory: "/studyTourCategory/add", // 游学分类新增
  newUpdateStudyTourCategory: "/studyTourCategory/update", // 游学分类编辑
  newDeleteStudyTourCategory: "/studyTourCategory/delete", // 游学分类删除
}